<template>
	<section
		class="review-tab layout-center805"
	>
		<!-- the map -->
		<map-device
			:source-data="mapSource"
			:selected-areas-data.sync="tempInstance.areas"
			enable-geocoder
			:search-query="searchQuery"
			class="map-device layout_block-full_width"
			:campaign-id="instance.id"
			:without-control="!isEditModeOn"

			@update="updateMapbox"
			@searchListRequest="searchlistRequestHandler"
		/>

		<main class="wrapper cl-container">

			<div class="order-details cl-xs8">

				<div class="edit-button">
					<nice-button-2
						v-if="appSide === 'dsp' && !isEditModeOn && !NO_CHANGE_STATUSES.includes(instance.status)"
						class="inline-edit-button"
						icon="pencil-13"
						bordered
						@click="editModeOn"
					>
						{{ $t('campaign.campaign_edit') | capitalize }}
					</nice-button-2>

					<div
						v-if="isEditModeOn"
						class="control-buttons"
					>
						<nice-button-2
							class="inline-edit-button_control"
							filled
							bordered
							@click="applyChanges"
						>
							{{ $t('campaign.save') | capitalize}}
						</nice-button-2>

						<nice-button-2
							class="inline-edit-button_control"
							bordered
							@click="cancelChanges"
						>
							{{ $t('campaign.cancel') | capitalize}}
						</nice-button-2>
					</div>
				</div>

				<h3 class="order-section-title">{{ $t('campaign.city_label') | capitalize }}</h3>

				<NiceSelect
					v-if="isEditModeOn"
					v-model="tempInstance.cities"
					:options="getCityOptions"
					multiple
					show-check
					required
					class="cities"
					:invalid="!tempInstance.cities || tempInstance.cities.length === 0"
					:error="errors.cities"
				/>

				<ul class="selected-cities">
					<li
						v-for="(city, i) in instance.cities"
						:key="i"
					>—&nbsp;{{ city }}</li>
				</ul>

				<hr class="line" />


				<!-- Audience -->
				<h3 class="order-section-title">{{ $t('campaign.audience_label') | capitalize }}</h3>

				<AudienceCpv
					v-if="isEditModeOn"
					:age.sync="tempInstance.age"
					:gender.sync="tempInstance.gender"
					:errors="{
						// age: context.errors.age,
						// gender: context.errors.gender,
					}"
				/>
				<template v-else>
					<!-- age -->
					<div class="order-subsection">
						<h4 class="order-section-subtitle">{{ $t('campaign.age_label') | capitalize }}</h4>
						<div v-if="instance.age[0] != 0 && instance.age[1] != 100">
							<div class="detail detail-huge cl-xs8 cl-pad time_range-label"  >
								<nice-label class="label" :label="$t('campaign.age_range') | capitalize" />
								<span class="value">{{ instance.age[0] }}&nbsp;&mdash; {{ instance.age[1] }}</span>
							</div>
						</div>
						<p v-else class="order-section-value" >{{ $t('campaign.all') | capitalize }}</p>
					</div>


					<!-- gender -->
					<div class="order-subsection">
						<h4 class="order-section-subtitle">{{ $t('campaign.gender_label') | capitalize }}</h4>
						<p class="order-section-value" >{{ $t(`campaign.${instance.gender}`) | capitalize }}</p>
					</div>

					<hr class="line" />
					<!-- end: audience -->
				</template>

				<!-- schedule -->
				<h3 class="order-section-title">{{ $t('campaign.schedule') | capitalize }}</h3>

				<template v-if="isEditModeOn && appSide === 'dsp'" >
					<Schedule
							:time-period.sync="tempInstance.time_period"
							:time-range.sync="tempInstance.time_range"
							:schedule.sync="tempInstance.schedule"
							:show-advanced-settings="true"

							:errors="{
								// time_period: {
								// 	start: context.errors.start_date,
								// 	end: context.errors.end_date,
								// },
								// schedule: context.errors.schedule,
							}"
					/>
				</template>
				<!-- time period? it was on a previous screen -->
				<template v-else>
				<div
					class="order-subsection details cl-container cl-pad-no_sides"
				>
					<div class="detail detail-huge cl-xs4 cl-pad" >
						<nice-label class="label" :label="$t('campaign.time_period') | capitalize" />
						<span class="value">
							<span>{{ timePeriod || '—' }}</span>
						</span>
					</div>

					<div class="detail detail-huge cl-xs4 cl-pad" >
						<nice-label class="label" :label="$t('campaign.ad_flight') | capitalize" />
						<span class="value">
							<span>{{ adFlight || '—' }}</span>
							<span class="units">{{ $tc('campaign.days_won', adFlight) }}</span>
						</span>
					</div>

					<div class="detail detail-huge cl-xs8 cl-pad time_range-label" >
						<nice-label class="label" :label="$t('campaign.time_range') | capitalize" />
						<span class="value">{{ timeRangeHumanize[0] }}&nbsp;&mdash; {{ timeRangeHumanize[1] }}</span>
					</div>

					<div class="detail detail-huge cl-xs12 cl-pad" >
						<nice-label class="label" :label="$t('campaign.week_rule') | capitalize" />
						<span class="value">{{ weekRule || '—' }}</span>
					</div>
				</div>

				</template>

				<hr class="line" />

				<div
					class="order-subsection details cl-container cl-pad-no_sides"
				>

					<div class="detail detail-huge cl-xs4 cl-pad" >
						<nice-label class="label" :label="$t('campaign.payment_model') | capitalize" />
						<span class="value">
							<span>{{ $t(`payment_models.${currentPaymentModel.value}`) || '—' }}</span>
						</span>
					</div>

					<div
						v-if="isEditModeOn && appSide === 'dsp'"
						class="detail detail-huge cl-xs4 cl-pad"
					>
						<nice-input
							v-model.number="tempInstance.ad_duration"
							:label="$t('campaign.message_duration') | capitalize"
							type="number"
							min="1"
							max="300"
							step="1"
							required
						/>
					</div>

					<div v-else class="detail detail-huge cl-xs4 cl-pad" >
						<nice-label class="label" :label="$t('campaign.message_duration') | capitalize" />
						<span class="value">
							<span>{{ instance.ad_duration || '—' }}</span>
							<span class="units">{{ $tc('campaign.seconds_won', instance.ad_duration) }}</span>
						</span>
					</div>

					<div
						v-if="isEditModeOn && appSide === 'dsp'"
						class="frequency-limit detail detail-huge cl-xs4 cl-pad"
					>
						<nice-input
							v-model.number="tempInstance.ad_rate_per_hour"
							:label="$t('campaign.frequency_limit') | capitalize"
							type="number"
							min="1"
							max="720"
							step="1"
							:hint="$t('campaign.per_hour_per_device')"
							required
						/>
					</div>

					<div v-else class="frequency-limit detail detail-huge cl-xs4 cl-pad" >
						<nice-label class="label" :label="$t('campaign.frequency_limit') | capitalize" />
						<span class="value">
							<span>{{ instance.ad_rate_per_hour || '—' }}</span>
							<span
								class="units"
								v-html="$t('campaign.per_hour')"
							/>
						</span>
					</div>
				</div>

				<hr class="line" />

				<!-- budget -->
				<h3 class="order-section-title">{{ $t('campaign.budget') | capitalize }}</h3>
				<!-- time period? it was on a previous screen -->
				<div
					class="order-subsection details"
				>
					<div class="detail detail-huge" >
						<template v-if="isEditModeOn && appSide === 'dsp'" >
							<nice-input
								v-model="tempInstance.budget"
								:units="$options.filters.formatCurrency(instance.currency)"
								class="inline-edit-field inline-edit-field_huge"
								type="number"
								step="1"
								:label="$t('campaign.budget') | capitalize"
							/>
						</template>
						<template v-else>
							<nice-label class="label" :label="$t('campaign.budget') | capitalize" />
							<span class="value">
								<span>{{ $options.filters.formatNumber(instance.budget, decimal=2, separator='') || '—' }}</span>
								<span class="units">{{ instance.currency | formatCurrency }}</span>
							</span>
						</template>
					</div>


					<div class="detail detail-huge" >
						<template v-if="isEditModeOn && appSide === 'dsp'" >
							<nice-input
								v-model="tempInstance.daily_budget"
								:units="$options.filters.formatCurrency(instance.currency)"
								class="inline-edit-field inline-edit-field_huge"
								type="number"
								step="1"
								:label="$t('campaign.daily_budget') | capitalize"
							/>
						</template>
						<template v-else>
							<nice-label class="label" :label="$t('campaign.daily_budget') | capitalize" />
							<span class="value">
								<span>{{ $options.filters.formatNumber(instance.daily_budget, decimal=2, separator='') || '—' }}</span>
								<span class="units">{{ instance.currency | formatCurrency }}</span>
							</span>
						</template>
					</div>


					<div class="detail detail-huge" >
						<!-- v-else -->
						<template>
							<nice-label class="label" :label="$t('campaign.max_bid') | capitalize" />
							<span class="value">
								<span>{{ $options.filters.formatNumber(instance.max_bid, decimal=2, separator='') || '—' }}</span>
								<span class="units">{{ instance.currency | formatCurrency }}</span>
							</span>
						</template>
						<span class="extra">
							{{$t(`payment_models.${currentPaymentModel.value}`)}}
							{{$t('campaign.max_bid_extra_detail',{message_duration:$tc('campaign.seconds', instance.ad_duration)})}}
						</span>
					</div>
				</div>

				<div class="edit-button">
					<nice-button-2
						v-if="appSide === 'dsp' && !isEditModeOn && !NO_CHANGE_STATUSES.includes(instance.status)"
						class="inline-edit-button"
						icon="pencil-13"
						bordered
						@click="editModeOn"
					>
						{{ $t('campaign.campaign_edit') | capitalize }}
					</nice-button-2>

					<div
						v-if="isEditModeOn"
						class="control-buttons"
					>
						<nice-button-2
							class="inline-edit-button_control"
							filled
							bordered
							@click="applyChanges"
						>
							{{ $t('campaign.save') | capitalize}}
						</nice-button-2>

						<nice-button-2
							class="inline-edit-button_control"
							bordered
							@click="cancelChanges"
						>
							{{ $t('campaign.cancel') | capitalize}}
						</nice-button-2>
					</div>
				</div>
			</div>

		</main>
	</section>
</template>


<script>
import moment from 'moment';
import { debounce } from 'underscore';
import { mapState, mapActions, mapGetters } from 'vuex';

import apiDsp from '@/api/dsp/device';
import apiSsp from '@/api/ssp/device';
import { request, getBaseApiUrl } from '@/api/request';

import MapDevice from '@/components/map-device';
import NiceInput from '@/ui/nice-input';
import NiceSelect from '@/ui/nice-select';

import { getDevicesFilter, objectToQuery, deepCopy } from '@/utilites';
import { convertError } from '@/ui/utils/errors';

// we need full paths here
import AudienceCpv from '@/pages/request/create/audience-cpv';
import Schedule from '@/pages/request/create/schedule';

import {
	ARCHIVED as STATUS_ARCHIVED,
	DELETED as STATUS_DELETED,
	FINISHED as STATUS_FINISHED,
} from '@/constants/audit-status-codes';

const WEEK_DAYS_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

// milliseconds. 1 second is too short
const DEBOUNCE_TIMEOUT = 2000;

function formatDate(date) {
	return moment(date).format('DD MMM`YY');
}

const NO_CHANGE_STATUSES = [STATUS_ARCHIVED, STATUS_DELETED, STATUS_FINISHED];


export default {
	name: 'FlasterTabOrder',


	components: {
		MapDevice,
		NiceInput,
		NiceSelect,
		AudienceCpv,
		Schedule,
	},


	props: {
		// campaign
		instance: {
			type: Object,
			required: true,
		},

		resource: {
			type: String,
			default: 'request',
			validator: resource => [
				'request',
				'campaign',
			].includes(resource),
		},
	},


	data() {
		const {
			max_bid,
			payment_model,
			budget,
			daily_budget,
			ad_duration,
			ad_rate_per_hour,
			start_date,
			end_date,
			time_range,
			schedule,
			age,
			gender,
			environments,
			resolutions,
			orientations,
			device_types,
			areas,
			cities,
		} = this.instance;

		const innerInstance = {
			max_bid,
			payment_model,
			budget,
			daily_budget,
			ad_duration,
			ad_rate_per_hour,
			time_period: {
				start: start_date,
				end: end_date,
			},
			time_range,
			schedule,
			age,
			gender,
			environments,
			resolutions,
			orientations,
			device_types,
			areas,
			cities,
		};

		const tempInstance = { ...innerInstance };

		return {
			NO_CHANGE_STATUSES,

			isEditModeOn: false,

			mapSource: {
				'type': 'FeatureCollection',
				'features': [],
			},

			searchQuery: '',
			searchListRequest: [],

			innerInstance: Object.freeze(deepCopy(innerInstance)),
			tempInstance: deepCopy(tempInstance),

			stats: null,

			currentSelection: {
				// depends on payment_model
				'plays': {
					'value': 0,
					'total': 0,
				},
				'impressions': {
					'value': 0,
					'total': 0,
				},
				'inventory': {
					'value': 0,
					'total': 0,
					'excel_url': '',
				},
				'price': {
					'min': 0,
					'max': 0,
					'avg': 0,
				},
				// [{type: 'monitor', resolution: '1920x1080', count: 21,}, ...]
				'specs': [],

				'total_max_budget': 0,
			},

			errors: {},
		};
	},


	computed: {
		...mapState('app', {
			appSide: 'side',
		}),
		...mapState('extra', [
			'paymentModels',
			'broadcastTypes',
		]),
		...mapGetters('extra', [
			'getPaymentModelByValue',
			'getBroadcastTypeByValue',
		]),

		instanceJson() {
			return JSON.stringify(this.instance);
		},

		// time period
		timePeriod() {
			let start = this.instance.start_date;
			let end = this.instance.end_date;

			return `${ start ? formatDate(start) : '⋯' } — ${ end ? formatDate(end) : '⋯' }`;
		},

		// ad flight
		adFlight() {
			let start = this.instance.start_date;
			let end = this.instance.end_date;
			let diff = moment(end).diff(moment(start), 'days');

			if (isNaN(diff)) {
				return 0;
			}

			// moment.diff works like this `20191001-20191002 == 1`. we need 2
			return diff + 1;
		},

		currentPaymentModel() {
			return this.getPaymentModelByValue(this.instance.payment_model);
		},

		/**
		 * `schedule` is an object: {
		 *   fri: true​
		 *   mon: true
		 *   sat: true
		 *   sun: true
		 *   thu: true
		 *   tue: true
		 *   wed: true
		 * }
		 *
		 * We need to make the right order
		 */
		weekRule() {
			let days = WEEK_DAYS_ORDER.filter(day => this.instance.schedule[day]);

			if (!days.length) {
				return this.$options.filters.capitalize(this.$t('campaign.all'));
			}

			return days.map(day => this.$options.filters.capitalize(this.$t(day))).join(', ');
		},

		devicesFilter() {
			const inst = {
				...this.instance,
				...this.tempInstance,
			};
			// we need only deployed devices here
			let filter = getDevicesFilter(inst, true);
			return objectToQuery(filter);
		},

		timeRangeHumanize() {
			return [
				moment.utc(this.instance.time_range[0]*1000).format('HH:mm'),
				moment.utc(this.instance.time_range[1]*1000).format('HH:mm')
			];
		},
	},


	methods: {
		...mapActions('devices', ['getStats']),
		...mapActions('campaign', {
			'updateCampaign': 'change',
		}),

		formatDate,

		getApi() {
			return this.appSide == 'ssp' ? apiSsp : apiDsp;
		},

		setMapSource: debounce( async function setMapSource() {
			const apiPath = this.getApi().getPrefix().slice(0,-1);

			let filter = this.devicesFilter;
			// HACK: to show all devices if platform is not selected
			if (this.devicesFilter.indexOf('platforms') == -1) {
				filter += '&platforms=all';
			}

			const url = `${getBaseApiUrl()}${apiPath}.geojson${filter}`;

			const result = await request(url);

			this.$set(this, 'mapSource', result);
		}, DEBOUNCE_TIMEOUT),

		updateStats: debounce( async function updateStats() {
			const inst = {
				...this.instance,
				...this.tempInstance,
			};

			// only deployed devices
			let filter = objectToQuery(getDevicesFilter(inst, true));
			const response = await this.getStats({
				filter,
			});

			this.$set(this, 'currentSelection', response);
			this.$set(this, 'stats', response);
		}, DEBOUNCE_TIMEOUT),

		updateMapAndStats() {
			this.setMapSource();
			this.updateStats();
		},

		async getCityOptions(event) {
			const response = await this.getApi().networkCities(event.query);

			return response.results.map(city => ({
				value: city.city_name,
				label: city.city_name || ' ',  // clicks don't work w/o data
			}));
		},

		searchlistRequestHandler(e) {
			this.searchListRequest = e;
		},

		editModeOn() {
			this.isEditModeOn = true;
		},

		async applyChanges() {
			this.$set(this, 'innerInstance', Object.freeze(deepCopy(this.tempInstance)));

			const data = {
				...this.tempInstance,
				start_date: this.tempInstance.time_period.start,
				end_date: this.tempInstance.time_period.end,
			};

			delete data.time_period;

			try {
				await this.updateCampaign({
					id: this.instance.id,
					data: data,
				});
			} catch (error) {
				this.errors = convertError(error.response, ['start_date', 'end_date']);
				let message = this.$t('failed_to_save');
				if (this.errors) {
					const firstKey = Object.keys(this.errors)[0];
					message = this.errors[firstKey];
				}

				window.alert(message);

				this.$log.error(error);
				this.cancelChanges();
				throw error;
			}

			this.$emit('update');

			this.isEditModeOn = false;
		},

		cancelChanges() {
			this.$set(this, 'tempInstance', deepCopy(this.innerInstance));
			this.isEditModeOn = false;
		},

		updateMapbox() {
			this.$emit('update');
		}
	},

	watch: {
		instanceJson() {
			const {
				max_bid,
				payment_model,
				budget,
				daily_budget,
				ad_duration,
				ad_rate_per_hour,
				start_date,
				end_date,
				time_range,
				schedule,
				age,
				gender,
				environments,
				resolutions,
				orientations,
				device_types,
				areas,
			} = this.instance;

			const innerInstance = Object.freeze({
				max_bid,
				payment_model,
				budget,
				daily_budget,
				ad_duration,
				ad_rate_per_hour,
				time_period: {
					start: start_date,
					end: end_date,
				},
				time_range,
				schedule,
				age,
				gender,
				environments,
				resolutions,
				orientations,
				device_types,
				areas,
			});

			const tempInstance = { ...innerInstance };

			this.innerInstance = deepCopy(innerInstance);
			this.tempInstance = deepCopy(tempInstance);
		},

		//  This watcher is needed to update stats from tempInstance
		tempInstance: {
			deep: true,
			handler(instance) {
				this.updateMapAndStats();
			},
		},
	},


	async created() {
		return await Promise.all([
			this.$store.dispatch('extra/getPaymentModels'),
			this.$store.dispatch('extra/getBroadcastTypes', {
				platforms: this.instance.platforms || 'all',
				force: true,
				is_deployed: true
			}),

			this.updateMapAndStats(),
		]);
	},
};
</script>

<style lang="sass" scoped>
$width-limit: 330px

.wrapper
	flex-wrap: nowarp

.review-tab
	margin-top: -21px

.map-device
	height: 372px
	margin-bottom: 30px

.cities
	width: fit-content
	margin-bottom: 20px

.selected-cities
	margin: 0
	padding: 0
	list-style: none

.range-preview
	max-width: $width-limit

.line
	margin: 54px 0
	// max-width: $width-limit

.order-section-title
	font-size: 16px
	font-weight: normal
	line-height: 18px
	// margin: (30px - 18px) / 2 / 18px 0
	margin: 30px 0

.order-section-subtitle
	font-size: 14.5px
	font-weight: bold
	line-height: 18px
	margin: (30px - 18px) / 2 / 18px 0

.details .time_range-label
	margin-bottom: 0

.summary
	position: sticky
	top: 30px
	bottom: 30px


.details
	margin-bottom: -35px
	& > *
		margin-bottom: 35px

.detail
	display: flex
	flex-direction: column

.value
	display: flex
	align-items: center
	width: 100%
	line-height: 18px
	margin: (30px - 18px) / 2 0
	text-overflow: ellipsis

	&:not(.multiline)
		white-space: nowrap
		overflow: hidden

	& > *
		margin-left: .5em

	& > :first-child
		margin-left: 0

	& > .units,
	& > .shaded
		color: var(--text_2_color)


.detail-huge
	& > .label
		font-size: 11px

	& > .value
		font-weight: 300
		font-size: 16px

.detail-pad-right-33
	padding-right: 33%

.inline-edit-field
	display: inline-block
	width: 125px

	& ::v-deep .ni_input--units
		color: var(--text_2_color)


.inline-edit-field_huge
	margin-top: 2px

	&::v-deep
		.ni_label--label
			margin-bottom: 4px
			line-height: 24px
			font-size: 11px

		.ni_input--input,
		.ni_input--units
			font-weight: 300
			font-size: 16px

.edit-button
	display: flex
	justify-content: flex-end

.inline-edit-button
	width: 220px

	&_control
		width: 94px

.control-buttons
	display: flex
	justify-content: flex-end

	& > *
		margin-left: 16px

.frequency-limit
	position: relative

	&::before
		content: '<'
		color: $nice_color-darkgray
		position: absolute
		bottom: 9px
		left: -10px

::v-deep
	.mapboxgl-ctrl-geocoder.mapboxgl-ctrl
		visibility: hidden
		display: none
</style>
